import { render, staticRenderFns } from "./SortCalendarDescending.vue?vue&type=template&id=8ebcdfd6"
import script from "./SortCalendarDescending.vue?vue&type=script&lang=js"
export * from "./SortCalendarDescending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports